import { render, staticRenderFns } from "./tab6 copy.vue?vue&type=template&id=72eb5759&scoped=true&"
import script from "./tab6 copy.vue?vue&type=script&lang=js&"
export * from "./tab6 copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eb5759",
  null
  
)

export default component.exports